function getRepeatByGroupingKey(repeatByType = '') {
	const typeUppercase = repeatByType.charAt(0).toUpperCase() + repeatByType.slice(1)
	return `repeating${typeUppercase}Grouping`
}

function getRepeatByGroupingType(repeatByType = '') {
	return `repeating-${repeatByType}`
}

export { getRepeatByGroupingKey }
export { getRepeatByGroupingType }